import { Candidate } from '../../../../types';
export interface ApplicationFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  yearsOfExperience: number;
  lastDesignation: string;
  expectedSalary: string;
  coverLetter: string;
  additionalInfo: string;
}

export interface ApplicationState {
  formData: ApplicationFormData;
  loading: boolean;
  loadingProfile: boolean;
  submitSuccess: boolean;
  showConfirmModal: boolean;
  errors: Record<string, string>;
  profileError: string;
  candidateProfile: Candidate | null;
  toasts: Array<{ id: number; type: 'success' | 'error' | 'info' | 'warning'; message: string }>;
}

export interface ToastMessage {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

export const initialState: ApplicationState = {
  formData: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    yearsOfExperience: 0,
    lastDesignation: '',
    expectedSalary: '',
    coverLetter: '',
    additionalInfo: ''
  },
  loading: false,
  loadingProfile: true,
  submitSuccess: false,
  showConfirmModal: false,
  errors: {},
  profileError: '',
  candidateProfile: null,
  toasts: []
};

// Define action types
export type Action =
  | { type: 'SET_FORM_FIELD'; field: string; value: string | number }
  | { type: 'SET_FORM_DATA'; payload: Partial<ApplicationState['formData']> }
  | { type: 'SET_CANDIDATE_PROFILE'; payload: any }
  | { type: 'SET_LOADING_PROFILE'; payload: boolean }
  | { type: 'SET_PROFILE_ERROR'; payload: string }
  | { type: 'SET_SUBMIT_LOADING'; payload: boolean }
  | { type: 'SET_SUBMIT_SUCCESS'; payload: boolean }
  | { type: 'SET_SHOW_CONFIRM_MODAL'; payload: boolean }
  | { type: 'SET_ERRORS'; payload: Record<string, string> }
  | { type: 'CLEAR_FIELD_ERROR'; field: string }
  | { type: 'ADD_TOAST'; payload: { message: string; type: ToastMessage['type'] } }
  | { type: 'REMOVE_TOAST'; payload: number }
  | { type: 'RESET_FORM' };

// Reducer function
export const applyFormReducer = (state: ApplicationState, action: Action): ApplicationState => {
  switch (action.type) {
    case 'SET_FORM_FIELD':
      return {
        ...state,formData: {...state.formData,[action.field]: action.value}};

    case 'SET_FORM_DATA':
      return {
        ...state, formData: { ...state.formData, ...action.payload } };

    case 'SET_CANDIDATE_PROFILE':
      return {
        ...state, candidateProfile: action.payload};

    case 'SET_LOADING_PROFILE':
      return {
        ...state, loadingProfile: action.payload };

    case 'SET_PROFILE_ERROR':
      return {
        ...state,profileError: action.payload };

    case 'SET_SUBMIT_LOADING':
      return {
        ...state, loading: action.payload};

    case 'SET_SUBMIT_SUCCESS':
      return {
        ...state,submitSuccess: action.payload};

    case 'SET_SHOW_CONFIRM_MODAL':
      return {
        ...state,showConfirmModal: action.payload};

    case 'SET_ERRORS':
      return {
        ...state, errors: action.payload};

    case 'CLEAR_FIELD_ERROR':
      return {
        ...state,errors: {...state.errors,[action.field]: ''} };

    case 'ADD_TOAST': {
      const id = Date.now();
      return {
        ...state,toasts: [...state.toasts, { id, type: action.payload.type, message: action.payload.message }]};}

    case 'REMOVE_TOAST':
      return {
        ...state,toasts: state.toasts.filter(toast => toast.id !== action.payload) };

    case 'RESET_FORM':
      return {
        ...initialState,toasts: state.toasts };

    default:
      return state;
  }
};